import React, { createContext, useContext, useState, useEffect } from 'react'

const API = `${process.env.REACT_APP_BACKEND_URL}/api`

const DEFAULT_CONTENT = {
  hero: {
    line1: 'DISEÑO',
    line2: 'WEB.',
    subtitle: 'Diseñador Web Freelance · Córdoba',
    photo1_url: 'https://customer-assets-jai6qajn.emergentagent.net/job_be6b6d40-04a2-4626-96b0-39ae7bcf5dea/artifacts/sbxvain9_ChatGPT%20Image%2021%20sept%202026%2C%2023_45_37.png',
    photo2_url: 'https://customer-assets-39nsmqrw.emergentagent.net/job_design-osuna/artifacts/4s1kwr4y_ChatGPT%20Image%2022%20sept%202026%2C%2001_07_01.png',
  },
  sobre_mi: {
    headings: ['DETRÁS DE', 'CADA WEB,', 'ESTOY YO.'],
    bio1: 'Soy José, diseñador web freelance en Córdoba. Trabajo directamente con negocios y profesionales que quieren mejorar su presencia online.',
    bio2: 'Tú me cuentas qué necesitas, yo te propongo la mejor solución y me encargo de convertirla en una web profesional. Sin departamentos, sin intermediarios.',
    manifesto: [
      { num: '01', title: 'DISEÑO A MEDIDA', desc: 'Webs construidas desde cero con la imagen de tu negocio. Sin plantillas, sin atajos.' },
      { num: '02', title: 'ENTREGA EN 7 DÍAS', desc: 'Web Esencial en 7 días. Profesional con app en máximo 14. Sin precios de agencia.' },
      { num: '03', title: 'TRATO DIRECTO', desc: 'Sin departamentos ni intermediarios. Hablas conmigo directamente en cada paso.' },
      { num: '04', title: 'CÓDIGO TUYO', desc: 'Al finalizar, te entrego el código fuente completo. Tu web es tuya, sin ataduras.' },
    ],
  },
  projects: [
    {
      id: 'club1920', num: '01', title: 'CLUB 1920 BARBER',
      category: 'Diseño Web', subcategory: 'Barbería · Proyecto real', year: '2025',
      description: 'Web premium para barbería clásica: servicios, reservas y una presencia que transmite distinción.',
      long_description: 'Diseño con identidad visual clara y llamadas a la acción directas. Galería del local, listado de servicios y precios, y reserva online integrada para no perder ni un cliente.',
      tech: ['Diseño UI/UX', 'React', 'Reserva online', 'Diseño premium'],
      image: '/project-club1920.jpg', modal_image: '/project-club1920.jpg',
      url: 'https://club-1920-barber-shop.vercel.app/', no_url: false,
    },
    {
      id: 'nova_dental', num: '02', title: 'NOVA DENTAL',
      category: 'Diseño Web', subcategory: 'Clínica dental · Proyecto real', year: '2025',
      description: 'Web para clínica dental que transmite confianza: servicios claros, equipo visible y cita online.',
      long_description: 'Proyecto diseñado para convertir visitas en pacientes. Presentación del equipo, tratamientos con precios, formulario de cita online y testimonios de pacientes.',
      tech: ['Diseño UI/UX', 'React', 'Cita online', 'Diseño confianza'],
      image: '/project-nova_dental.jpg', modal_image: '/project-nova_dental.jpg',
      url: 'https://nova-dental-topaz.vercel.app/', no_url: false,
    },
    {
      id: 'xatarra', num: '03', title: 'XATARRA BRUTAL BAR',
      category: 'Diseño Web', subcategory: 'Bar urbano · Proyecto real', year: '2026',
      description: 'Referente en Córdoba para fútbol en directo, terraceo y el mejor ambiente nocturno.',
      long_description: 'Web con personalidad propia para un bar urbano único. Eventos de fútbol en directo, galería del local, carta de cócteles y enlace directo a redes sociales.',
      tech: ['Diseño UI/UX', 'React', 'Eventos tiempo real', 'Galería multimedia'],
      image: '/project-xatarra.jpg', modal_image: '/project-xatarra.jpg',
      url: 'https://xatarra-brutal-bar.vercel.app/', no_url: false,
    },
    {
      id: 'brasa47', num: '04', title: 'BRASA 47',
      category: 'Diseño Web', subcategory: 'Restaurante · Proyecto real', year: '2025',
      description: 'Web para restaurante de cocina a la brasa: carta, galería, historia y reserva de mesa online.',
      long_description: 'Diseño cuidado para un restaurante con carácter. Carta digital interactiva, galería de platos, historia del local y sistema de reservas integrado.',
      tech: ['Diseño UI/UX', 'React', 'Carta digital', 'Reservas online'],
      image: '/project-brasa47.jpg', modal_image: '/project-brasa47.jpg',
      url: 'https://brasa-47-lilac.vercel.app/', no_url: false,
    },
    {
      id: 'urban_barber', num: '05', title: 'URBAN BARBER SHOP',
      category: 'Diseño Web', subcategory: 'Barbería · Proyecto real', year: '2026',
      description: 'Diseño moderno para barbería urbana: servicios, equipo y reserva directa sin llamadas.',
      long_description: 'Web para una barbería con estilo propio. Muestra al equipo de barberos, los servicios con precios y permite reservar cita directamente desde el móvil.',
      tech: ['Diseño UI/UX', 'React', 'Reserva móvil', 'Identidad visual'],
      image: '/project-urban_barber.jpg', modal_image: '/project-urban_barber.jpg',
      url: 'https://urbanbarbershop-nu.vercel.app/', no_url: false,
    },
  ],
}

const SiteContentContext = createContext(DEFAULT_CONTENT)

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT)

  useEffect(() => {
    fetch(`${API}/content`)
      .then((r) => r.json())
      .then((data) => {
        if (data && data.hero) setContent(data)
      })
      .catch(() => {})
  }, [])

  const saveContent = async (newContent, token) => {
    const res = await fetch(`${API}/admin/content`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newContent),
    })
    if (!res.ok) throw new Error('Error al guardar')
    setContent(newContent)
  }

  return (
    <SiteContentContext.Provider value={{ content, setContent, saveContent }}>
      {children}
    </SiteContentContext.Provider>
  )
}

export const useSiteContent = () => useContext(SiteContentContext)
export { DEFAULT_CONTENT }
